import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/dist/query";
import { avatarStageReducer } from "src/reducks/AvatarStageStore";
import { avatarReducer } from "src/reducks/AvatarStore";
import { backgroundReducer } from "src/reducks/BackgroundStore";
import { searchReducer } from "src/reducks/SearchStore";
import { serverApi } from "src/service";

export const store = configureStore({
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(serverApi.middleware);
  },

  reducer: {
    [serverApi.reducerPath]: serverApi.reducer,
    avatar: avatarReducer,
    avatarStage: avatarStageReducer,
    background: backgroundReducer,
    search: searchReducer,
  },
});

setupListeners(store.dispatch);
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
